import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";

export const professionListLoader: LoaderFunction = async (args) => {
    const result = await axiosApi.get("/api/professions");

    return result.data
}